<template>
  <div class="add-pay-box">
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="960px"
        top="10px"
        :before-close="handleClose"
        :close-on-click-modal="false"
    >
      <el-form
          ref="form"
          :model="params"
          :rules="rules"
          label-width="150px"
          :label-position="labelPosition"
      >
        <div class="form-flex-box">
          <el-form-item label="背景图:(竖)" prop="bgImg">
            <base-upload
                class="upload"
                :key="params.bgImg"
                :cover="params.bgImg"
                :action="action"
                :wSize="180"
                :hSize="190"
                :width="'180px'"
                :height="'190px'"
                @successCallback="handleAvatarSuccess"
            ></base-upload>
          </el-form-item>
          <el-form-item label="背景图2(大横):" prop="bgImg2">
            <base-upload
                class="upload"
                :key="params.bgImg2"
                :cover="params.bgImg2"
                :action="action"
                :wSize="260"
                :hSize="150"
                :width="'260px'"
                :height="'150px'"
                @successCallback="handleAvatarSuccess2"
            ></base-upload>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <div class="item-box el-form-item">
            <el-form-item label="名称(不可重复):" prop="productName">
              <el-input v-model="params.productName" size="small"></el-input>
            </el-form-item>
          </div>
            <div class="item-box el-form-item">
            <el-form-item label="原价(金币):" prop="originalPrice">
              <el-input
                  v-model.number="params.originalPrice"
                  size="small"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-flex-box">
          <el-form-item label="现价(金币):" prop="discountedPrice">
            <el-input
                placeholder="请输入现价(金币)"
                v-model.number="params.discountedPrice"
                size="small"
                style="width: 160px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="私信价格:" prop="chatPrice">
            <el-select size="small" v-model.number="params.chatPrice">
                <el-option :value="0">0</el-option>
                <el-option :value="50">50</el-option>
                <el-option :value="100">100</el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="产品类型:" prop="productType">
            <el-select
                v-model="params.productType"
                size="small"
                clearable
                placeholder="请选择产品类型"
            >
              <el-option
                  v-for="item in productTypeList"
                  :value="item.value"
                  :label="item.label"
                  :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="持续时间(天):" prop="duration">
            <el-input v-model.number="params.duration" size="small"></el-input>
          </el-form-item>
          <el-form-item label="返场时间(小时):" prop="returnKeepTime">
            <el-input v-model.number="params.returnKeepTime" size="small"></el-input>
          </el-form-item>
        </div>
        <div v-if="params.productType === 9" class="form-flex-box">
          <el-form-item label="可领楼凤(次/周):" prop="timesAWeek">
            <el-input
                v-model.number="params.timesAWeek"
                size="small"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="楼凤折扣率(%):" prop="louFengDiscount">
            <el-input
                v-model.number="params.louFengDiscount"
                size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="金币视频免费限制:" prop="goldVideoFreeLimit">
            <el-input
                v-model.number="params.goldVideoFreeLimit"
                size="small"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="展示单价:">
            <el-switch v-model="params.unitPriceDisplay"></el-switch>
          </el-form-item>
          <el-form-item label="上架:">
            <el-switch v-model="params.status"></el-switch>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="产品位置:" prop="position">
            <el-select
                v-model="params.position"
                size="small"
                clearable
                placeholder="请选择产品位置"
            >
              <el-option
                  v-for="item in positionTypeList"
                  :value="item.value"
                  :label="item.label"
                  :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用金币购买:">
            <el-switch v-model="params.isAmountPay"></el-switch>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="金币视频免费天数:" prop="goldVideoFreeDay">
            <el-input
                v-model.number="params.goldVideoFreeDay"
                size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="排序:" prop="sort">
            <el-input v-model.number="params.sort" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="赠送金币数量:" prop="giveCoin">
            <el-input
                v-model.number="params.giveCoin"
                size="small"
            ></el-input>
          </el-form-item>
<!--          <el-form-item label="楼凤解锁次数:" prop="louFengUnlockTimes">-->
<!--            <el-input-->
<!--                v-model.number="params.louFengUnlockTimes"-->
<!--                size="small"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
              label="新手卡倒计时:"
              prop="showCountdownTime"
              v-if="this.params.productType == 5"
          >
            <el-input
                v-model.number="params.showCountdownTime"
                size="small"
                placeholder="单位：小时"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item
              label="会员等级:"
              prop="vipLevel"
              v-if="this.params.productType === 0 || this.params.productType == 5"
          >
            <el-select
                v-model="params.vipLevel"
                size="small"
                clearable
                placeholder="请选择会员等级"
            >
              <el-option
                  v-for="item in vipLevelTypeList"
                  :value="item.value"
                  :label="item.label"
                  :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="赠送观影券数量:" prop="couponNum">
            <el-input
                v-model.number="params.couponNum"
                size="small"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box" style="width: 300px">
          <el-form-item label="特权:" prop="privilege">
            <el-select
                v-model="params.privilege"
                multiple
                placeholder="请选择特权"
                class="privileges">
              <el-option
                  v-for="item in privileges"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
            <span class="red fz12 fw">备注：数字代表排序（小->大）</span>
          </el-form-item>
        </div>
        <el-form-item label="备注:" prop="desc">
          <el-input
              type="textarea"
              v-model="params.desc"
              size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="特权描述:" prop="privilegeDesc">
          <el-input
              type="textarea"
              v-model="params.privilegeDesc"
              size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动描述:" prop="actionDesc">
          <el-input
              type="textarea"
              v-model="params.actionDesc"
              size="small"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
            type="primary"
            @click="submitForm('form')"
            :loading="flag"
            size="small"
        >确 认
        </el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
import {validatorIndex} from "@/utils/validator";

export default {
  data() {
    return {
      labelPosition: "left",
      dialogVisible: false,
      title: "",
      flag: false,
      id: "",
      type: "",
      action: baseConfig.baseServerUrl + "/agent/upload/static",
      products: [
        {label: "铂金卡(月度会员)", value: 1},
        {label: "钻石卡(季度会员)", value: 2},
        {label: "至尊卡(年度会员)", value: 3},
      ],
      productTypeList: [
        {label: "会员卡", value: 0},
        {label: "约会卡", value: 3},
        {label: "新手卡", value: 5},
        {label: "实体商品", value: 6},
        {label: "楼凤优惠卡", value: 9},
        {label: "楼凤全免卡", value: 10},
        {label: "限时返场卡", value: 18},
        {label: "其它卡", value: 20},
      ],
      vipLevelTypeList: [
        {label: "VIP", value: 1},
        {label: "超级VIP", value: 2},
      ],
      positionTypeList: [],
      privileges: [],
      params: {
        productName: "",
        desc: "",
        duration: "",
        returnKeepTime: "",
        originalPrice: "",
        discountedPrice: "",
        chatPrice: '',
        sort: "",
        goldVideoFreeLimit: "",
        vipLevel: "",
        bgImg: "",
        bgImg2: "",
        status: false,
        unitPriceDisplay: false,
        productType: "",
        position: "",
        actionDesc: "",
        privilegeDesc: "",
        showCountdownTime: 24,
        couponNum: 0,
        isAmountPay: false,
        giveCoin: "",
        giveGameCoin: "",
        louFengUnlockTimes: "",
        goldVideoFreeDay: "",
      },
      rules: {
        productName: [
          {required: true, message: "请输入名称", trigger: "blur"},
        ],
        duration: [
          {
            pattern: /^(0|\+?[1-9][0-9]{0,4})$/,
            message: "最大不能超过99999",
            trigger: "blur",
          },
        ],
        returnKeepTime: [
          {
            pattern: /^(0|\+?[1-9][0-9]{0,4})$/,
            message: "最大不能超过99999",
            trigger: "blur",
          },
        ],
        originalPrice: [
          {required: true, message: "请输入原价", trigger: "blur"},
          {validator: validatorIndex, trigger: "blur"},
        ],
        discountedPriceIos: [
          {required: true, message: "请输入IOS现价", trigger: "blur"},
          {validator: validatorIndex, trigger: "blur"},
        ],
        discountedPriceAnd: [
          {required: true, message: "请输入安卓现价", trigger: "blur"},
          {validator: validatorIndex, trigger: "blur"},
        ],
        sort: [
          {required: true, message: "请输入排序", trigger: "blur"},
          {validator: validatorIndex, trigger: "blur"},
        ],
        goldVideoFreeDay: [
          {
            pattern: /^(0|\+?[1-9][0-9]{0,4})$/,
            message: "最大不能超过99999",
            trigger: "blur",
          },
        ],
        position: [
          {required: true, message: "请选择产品位置", trigger: "blur"},
        ],
        timesAWeek: [
          {required: true, message: "请输入每周可领次数", trigger: "blur"},
        ],
        louFengDiscount: [
          {required: true, message: "请输入楼凤折扣率", trigger: "blur"},
        ],
      },
    };
  },
  methods: {
    getProductList() {
      const param = {
        pageNumber: 1,
        pageSize: 50,
      };
      API.privilegeList(param)
          .then((res) => {
            this.privileges = [];
            if (res.code === 200 && res.data.length > 0) {

              res.data.forEach(element => {
                this.privileges.push({
                  label: element.privilegeName+"("+element.sort+")",
                  value: element.id,
                  privilegeDesc: element.privilegeDesc
                });
              });
            }
          })
          .catch(() => {
          });
    },
    //获取产品位置
    getNames() {
      this.loading = true;
      API.getNames(this.param)
          .then((res) => {
            if (res.code === 200 && res.data.list.length > 0) {
              this.positionTypeList = res.data.list.map((item, index) => {
                let positionObj = {};
                positionObj.key = index;
                positionObj.value = item;
                return positionObj;
              });
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.addProduct();
          } else {
            this.editProduct();
          }
        } else {
          return false;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        productName: "",
        desc: "",
        duration: "",
        returnKeepTime: "",
        originalPrice: "",
        discountedPrice: "",
        chatPrice: '',
        sort: 0,
        status: false,
        unitPriceDisplay: false,
        vipLevel: "",
        bgImg: "",
        position: "",
        actionDesc: "",
        privilegeDesc: "",
        showCountdownTime: "",
        couponNum:0,
        isAmountPay: "",
        productType: "",
        timesAWeek: undefined,
        louFengDiscount: undefined,
        giveCoin: "",
      };
      this.$refs["form"].resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.getNames();
      this.getProductList();
      this.type = type;
      this.dialogVisible = true;
      if (type === "edit") {
        this.title = "编辑VIP商品";
        this.params = {...data};
        this.id = data.id;
      } else {
        this.title = "新增VIP商品";
      }
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.params.bgImg = res.data.coverImg;
      this.$forceUpdate();
    },

    // 标签封面上传成功回掉
    handleAvatarSuccess2(res) {
      this.$log("res",res)
        this.params.bgImg2 = res.data.coverImg;

      this.$forceUpdate();
    },

    // 新增商品
    addProduct() {
      API.getNewSection(this.params)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.$emit("handlerProductList");
              this.getProductList()
            } else {
              this.$message.error("添加失败");
            }
            this.handleClose();
            this.flag = false;
          })
          .catch(() => {
            this.handleClose();
            this.flag = false;
          });
    },
    // 编辑商品
    editProduct() {
      let form = Object.assign(this.params, {
        id: this.id,
        actionDesc: this.params.actionDesc
            ? this.params.actionDesc
            : "ZERO_VALUE",
        privilegeDesc: this.params.privilegeDesc
            ? this.params.privilegeDesc
            : "ZERO_VALUE",
      });
      API.getEditSection(form)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "编辑成功",
                type: "success",
              });
              this.$emit("handlerProductList");
              this.getProductList()
            } else {
              this.$message.error("编辑失败");
            }
            this.handleClose();
            this.flag = false;
          })
          .catch(() => {
            this.handleClose();
            this.flag = false;
          });
    },
  },
};
</script>

<style lang="scss">
.add-pay-box {
  .el-input {
    width: 150px;
  }

  .flex-item {
    width: 90%;
    display: flex;

    .el-form-item {
      flex: 1;
    }
  }

  .form-flex-box {
    display: flex;

    .el-form-item {
      flex: 1;
    }

    .item-box {
      display: flex;
      flex-direction: column;
    }
  }

  .avatar-uploader {
    width: 150px;
    height: 150px;
  }

  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border: 1px dashed #e63765;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  .privileges .el-input--suffix {
    width: 480px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;

    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
